.screen {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/*
 * Панель журнала: ДВЕ строки, как в макете «Журнал - П0» — навигация по дням и «Новая
 * запись» сверху, шаг, отменённые и сводка дня под ними (см. journal-screen.tsx).
 *
 * НИ ОДИН ЭЛЕМЕНТ НЕ СЖИМАЕТСЯ И НЕ ПЕРЕНОСИТ ПОДПИСЬ ВНУТРИ СЕБЯ. Кнопка, у которой
 * «Один мастер» стоит в две строки, читается как поломка раньше, чем её прочитают.
 * Если строке не хватает ширины (1024 с иконочной навигацией), она переносится ЦЕЛИКОМ
 * по элементам, а не ломает их по буквам. Сжимается только сводка — у неё многоточие.
 */
.toolbar {
  display: flex;
  flex: none;
  flex-direction: column;
  font-size: var(--font-size-md);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.toolbarRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  min-height: var(--toolbar-height);
  padding: 4px var(--space-4);
}

.toolbarRow + .toolbarRow {
  border-top: 1px solid var(--border);
}

.toolbarRow > * {
  flex: none;
  white-space: nowrap;
}

/* Распорка первой строки: «+ Новая запись» прижимается вправо, как в шапке макета. */
.toolbarSpacer {
  flex: 1 1 0;
  min-width: 0;
}

/*
 * Сегментный переключатель: «День · Неделя · Один мастер» и шаг сетки. Одна рамка
 * на группу, а не три отдельные пилюли — так в макете, и так читается, что выбрать
 * можно ОДНО из трёх, а не включить несколько.
 */
.segmented {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  background: var(--bg-workspace);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.segment {
  padding: 4px 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: 1.3;
  color: var(--text-secondary);
  white-space: nowrap;
  cursor: pointer;
  background: none;
  border: 0;
  border-radius: 6px;
}

.segment:hover {
  color: var(--text-brand);
}

.segmentActive,
.segmentActive:hover {
  color: var(--text-on-nav-active);
  background: var(--bg-nav);
}

.stepGroup {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dateNav {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  background: var(--bg-workspace);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.dateStep {
  width: 26px;
  height: 26px;
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: 0;
  border-radius: 6px;
}

.dateStep:hover {
  background: var(--bg-sunken);
}

.dateLabel {
  min-width: 150px;
  padding: 0 6px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  text-align: center;
}

.today {
  padding: 5px 10px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 7px;
}

.chips {
  display: flex;
  align-items: center;
  gap: 6px;
}

.chipLabel {
  color: var(--text-secondary);
}

.chip {
  padding: 3px 9px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  white-space: nowrap;
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
}

.chipActive {
  color: var(--text-on-nav-active);
  background: var(--bg-nav);
  border-color: var(--bg-nav);
}

/*
 * Сводка дня, прижатая вправо. Считается по тем же записям, что уже нарисованы в сетке:
 * второй запрос ради четырёх чисел — это ещё одна причина, по которой журнал может
 * разойтись сам с собой.
 */
.summary {
  /* Единственный сжимаемый элемент панели: уступает место кнопкам, а не наоборот. */
  flex: 1 1 0 !important;
  min-width: 0;
  margin-left: auto;
  overflow: hidden;
  text-align: right;
  font-size: var(--font-size-sm);
  font-variant-numeric: tabular-nums;
  color: var(--text-brand);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.placeholder {
  margin: var(--space-5) var(--space-4);
  padding: 22px 18px;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  background: var(--bg-workspace);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
}

/* Панель журнала на телефоне: строки уже переносятся сами, здесь только поля и сводка. */
@media (max-width: 767px) {
  .toolbarRow {
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3);
  }

  .summary {
    flex-basis: 100% !important;
    margin-left: 0;
    text-align: left;
    white-space: normal;
  }
}

/*
 * Рабочая область дня. Позиционирование здесь не оформление, а условие: панель записи,
 * быстрая форма и диалоги ложатся ПОВЕРХ сетки и относительно неё, а не относительно
 * окна браузера. Сетка при этом остаётся видимой — «перенести на 18:30» проверяется
 * взглядом в соседнюю колонку, не закрывая панель.
 */
.work {
  position: relative;
  flex: 1;
  min-height: 0;
}

/*
 * Отказ снятия удержания. Плашка внимания, а не ошибки: слот, скорее всего, всё ещё
 * держится, и день уже перечитан — человеку надо решить, звонить ли клиенту, а не
 * получить красный крест. Закрывается рукой: это ответ на его действие.
 */
.holdFailure {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  margin: 0 var(--space-4) var(--space-2);
  padding: 8px 12px;
  font-size: var(--font-size-sm);
  color: var(--note-fg);
  background: var(--note-bg);
  border-radius: var(--radius-sm);
}

.holdFailureClose {
  margin-left: auto;
  padding: 2px 10px;
  font: inherit;
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: 1px solid currentcolor;
  border-radius: var(--radius-sm);
}
